import { gql } from "@apollo/client";

export const GET_SCHEDULES = gql`
    query schedules($projectId: String!) {
        schedules(projectId: $projectId) {
            id
            cron
            active
            nextRunTime
            lastRuntime
            company {
                name
                sysId
            }
            schedule {
                schedName
                startTime
                timeZone
                additionalInfo
            }
            user_input
        }
    }
`;

export const GET_COMPANIES = gql`
    query companies {
        companies {
            id
            name
            ops
        }
    }
`;

export const GET_PROJECTS = gql`
    query projects($showGlobal: Boolean) {
        getUserProjects(showGlobal: $showGlobal) {
            id
            projectId
            name
            description
            companySysId
            companyName
            userInputs
        }
    }
`;

export const GET_VARIABLE = gql`
    query refs($className: String!, $query: JSON!, $offset: Int, $limit: Int) {
        configurationItems(className: $className, query: $query, take: $limit, offset: $offset) {
            sysId
            name
        }
    }
`;

export const GET_PROJECT_RUN_HISTORY = gql`
    query ProjectRunHistory($projectId: String, $showRunning: Boolean) {
        getRunHistory(projectId: $projectId, showRunning: $showRunning) {
            id
            companyName
            user {
                id
                name
            }
            lastUpdatedOn
            createdOn
            results
            outputs
            error
            state
        }
    }
`;

export const GET_ALARM_POLICIES = gql`
    query policies($companyId: String) {
        alarmPolicies(companySysId: $companyId) {
            id
            companyId
            alarmType
            type
            policies {
                id
                name
                project {
                    id
                    name
                }
                filter {
                    severity
                    includedCis
                    includedCiQuery
                }
                evaluationPolicy {
                    timeWindow
                    numberOfIssues
                }
                roles
            }
        }
    }
`;

export const GET_POLICY_ACTIONS = gql`
    query actions($projectId: String) {
        policyActions(projectId: $projectId) {
            id
            name
            type
            project {
                id
                name
            }
            filter {
                severity
                includedCis
                includedCiQuery
                includedResources
            }
            evaluationPolicy {
                timeWindow
                numberOfIssues
            }
            roles
            triggerExpirationTimeSeconds
        }
    }
`;

export const GET_POLICY_ACTIONS_BY_TYPE = gql`
    query actions($type: String) {
        policyActionsByType(type: $type) {
            id
            name
            type
            project {
                id
                name
            }
            filter {
                severity
                includedCis
                includedCiQuery
            }
            evaluationPolicy {
                timeWindow
                numberOfIssues
            }
            roles
        }
    }
`;

export const GET_AUTOREQ_TRACES = gql`
    query traces($queryParams: QueryTraceParams) {
        trace(params: $queryParams)
    }
`;

export const GET_ME = gql`
    query me {
        me {
            id
            name
            display
            primaryTeam
            isAdmin
        }
    }
`;

export const GET_MANAGED_COMPANIES = gql`
    query managedCompanies($companySysId: String) {
        managedCompanies(companySysId: $companySysId)
    }
`;
